import { useEffect, useRef, useState } from 'react';
import { Container, Text } from '@pixi/react';
import { CreateTextWinAmountAndCurrencySymbolProps } from '../index.types';
import { isoStandard } from '../../../../helpers';
import { useStore } from '../../../../../hooks';

export const CreateTextWinAmountAndCurrencySymbol: React.FC<Partial<CreateTextWinAmountAndCurrencySymbolProps>> = ({
  x = 0,
  y = 0,
  amount,
  margin = 20,
  fontSize = 16,
  color = '#FFC33E',
}) => {
  const { gameStore } = useStore();
  const winRef: any = useRef(null);
  const [currencyCodeTestX, setCurrencyCodeTestX] = useState(0);
  const styles = {
    fill: color,
    align: 'center',
    fontWeight: '700',
    fontSize: fontSize,
    fontFamily: 'poppinsMedium',
  };

  useEffect(() => {
    if (winRef.current) {
      setCurrencyCodeTestX(winRef.current.width / 2 + margin);
    };
  }, [margin, winRef]);

  return (
    <Container x={x} y={y}>
      <Text
        anchor={0.5}
        ref={winRef}
        resolution={2}
        {...({ style: styles } as any)}
        text={amount ? `${isoStandard(amount as number)} ${gameStore.currencySymbol}` : ''}
      />
    </Container>
  );
};
